import { Grid, Typography } from '@material-ui/core'
import styled, { css } from 'styled-components'

export const StyledTopicFilterTitle = styled(Typography)<{ $loading?: boolean }>`
  text-align: center;
  font-weight: 500;
  font-size: ${props => props.theme.typography.pxToRem(15)};
  margin-bottom: ${props => props.theme.typography.pxToRem(31)};

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
    margin-bottom: ${props => props.theme.typography.pxToRem(66)};
  }

  &:focus {
    outline: ${props => props.theme.typography.pxToRem(1)} auto -webkit-focus-ring-color;
  }

  transition: opacity 0.5s ease-in-out;
  opacity: 1;
  will-change: opacity;

  ${props => props.$loading && css`
    opacity: 0.3;
  `}
`

export const StyledTopicFilterOption = styled(Typography)`
  text-align: center;
  font-size: ${props => props.theme.typography.pxToRem(18)};
  color: #1c1f2a;
`

export const StyledTopicFilterOptionWrapper = styled.button`
  padding: ${props => props.theme.typography.pxToRem(10)} ${props => props.theme.typography.pxToRem(30)};
  background-color: ${props => props.theme.palette.background.default};
  border: solid 1px rgba(112, 112, 112, 0.18);
  border-radius: ${props => props.theme.typography.pxToRem(4)};

  &.active {
    border-top: solid ${props => props.theme.typography.pxToRem(3)} ${props => props.theme.palette.secondary.main};
  }

  &:hover,
  &:focus {
    cursor: pointer;
    border-color: ${props => props.theme.palette.primary.main};
  }
`

export const StyledTopicFilterRow = styled(Grid)`
  gap: ${props => props.theme.typography.pxToRem(20)};
`
